// extracted by mini-css-extract-plugin
export var cardSectionsDivider = "styles-module__cardSectionsDivider___V65P4";
export var container = "styles-module__container___OhtIo";
export var textContainer = "styles-module__textContainer___u6_q7";